import React from 'react'
import Button from '../../../components/button/Button'
import ParentDataTable from '../../../components/data-table/ParentDataTable'
import editIcon from '../../../assets/icons/edit-icon.svg'
import deleteIcon from '../../../assets/icons/delete.svg'
import './batchTable.scss'
function BatchTable() {
  const actionBody = () => {
    return (
      <>
        <div className='action-body'>
          <Button className={'calendar-arrow right-icon'}>
            <img src={editIcon} alt='Accept' />
          </Button>
          {/* <Button className={'calendar-arrow delete-icon'}>
            <img src={deleteIcon} alt='Accept' />
          </Button> */}
        </div>
      </>
    )
  }
  const batchList = [
    {
      branch: 'Maninagar',
      batch: '2024',
    },
    {
      branch: 'Test',
      batch: '2022',
    },
    {
      branch: 'Check',
      batch: '2023',
    },
  ]
  const columns = [
    {
      sortable: false,
      field: 'branch',
      header: 'Branch',
      style: { minWidth: '12rem' },
    },
    {
      sortable: false,
      field: 'batch',
      header: 'Batch',
      style: { minWidth: '12rem' },
    },
    {
      sortable: false,
      field: '',
      header: 'Action',
      //   style: { minWidth: '12rem' },
      body: actionBody,
    },
  ]
  return (
    <div className='batchTable-card'>
      <ParentDataTable value={batchList} rows={batchList.length} columns={columns} pagination={false} />
    </div>
  )
}

export default BatchTable
